import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, MapPin, Star } from "lucide-react";
import styles from "./RepAndComments.module.scss";

const RepAndComments = ({ comment }) => {
  const navigate = useNavigate();

  const sender = comment?.userSender;
  const displayName =
    sender?.type === "COMPANY"
      ? sender?.razon_social
      : [sender?.name, sender?.last_name].filter(Boolean).join(" ");

  const skills = useMemo(
    () =>
      (comment?.skills || [])
        .map((skill) => skill?.skill?.name)
        .filter(Boolean),
    [comment?.skills],
  );

  const ratingValue = typeof comment?.stars === "number" ? comment.stars.toFixed(1) : null;

  const handleRedirectToProfile = () => {
    if (sender?.id) {
      navigate(`/perfil/${sender.id}`);
    }
  };

  return (
    <article className={styles.card}>
      <header className={styles.cardHeader}>
        <button type="button" className={styles.identity} onClick={handleRedirectToProfile}>
          {sender?.image_profile ? (
            <img src={sender.image_profile} alt={displayName} />
          ) : (
            <span className={styles.initials}>
              {(displayName || "U").charAt(0).toUpperCase()}
            </span>
          )}
          <div className={styles.identityInfo}>
            <span className={styles.identityLabel}>Usuario</span>
            <p className={styles.identityName}>{displayName || "Usuario"}</p>
            <div className={styles.identityMeta}>
              <CheckCircle2 className={styles.identityMetaIcon} />
              <span>{sender?.validated ? "Verificado" : "Sin verificación"}</span>
            </div>
          </div>
        </button>
        {ratingValue && (
          <div className={styles.rating}>
            <Star className={styles.ratingIcon} size={16} />
            <span className={styles.ratingValue}>{ratingValue}</span>
          </div>
        )}
      </header>
      <div className={styles.body}>
        {skills.length > 0 && (
          <div className={styles.section}>
            <span className={styles.sectionLabel}>
              <MapPin size={14} />
              Rubro
            </span>
            <div className={styles.tags}>
              {skills.map((skill) => (
                <span key={skill} className={styles.tag}>
                  {skill}
                </span>
              ))}
            </div>
          </div>
        )}
        {comment?.comment && (
          <div className={styles.section}>
            <span className={styles.sectionLabel}>Comentario</span>
            <p className={styles.commentText}>{comment.comment}</p>
          </div>
        )}
      </div>
      <footer className={styles.footer}>
        <span className={styles.date}>
          {comment?.createdAt
            ? new Date(comment.createdAt).toLocaleDateString()
            : "Sin fecha"}
        </span>
      </footer>
    </article>
  );
};

export default RepAndComments;
